import { render, staticRenderFns } from "./head_big.vue?vue&type=template&id=3e223fbc&scoped=true&"
import script from "./head_big.vue?vue&type=script&lang=js&"
export * from "./head_big.vue?vue&type=script&lang=js&"
import style0 from "./head_big.vue?vue&type=style&index=0&id=3e223fbc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e223fbc",
  null
  
)

export default component.exports